'use client';

import Script from 'next/script';

/**
 * Microsoft Clarity - Free forever unlimited session recording.
 * Recommended over Hotjar for the bioinformatics blog's high-traffic plans.
 */
export function MicrosoftClarity() {
  const clarityId = process.env.NEXT_PUBLIC_CLARITY_ID;

  if (!clarityId) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('⚠️ Microsoft Clarity ID not found in .env.local');
    }
    return null;
  }

  return (
    <Script
      id='microsoft-clarity'
      strategy='afterInteractive'
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${clarityId}");
        `
      }}
    />
  );
}
